import { LanguageDetectorModule } from "i18next"
import queryString from "query-string"
import availableLanguages from "./languages"

const LanguageDetector: LanguageDetectorModule = {
  type: "languageDetector",
  detect: () => {
    let lang = availableLanguages[0]
    if (typeof window !== "undefined") {
      let { search } = window?.location
      if (
        !window?.location.search &&
        window?.location.hash &&
        window?.location.hash.indexOf("?") > -1
      ) {
        search = window?.location.hash.substring(
          window?.location.hash.indexOf("?")
        )
      }
      const values = queryString.parse(search)
      const foundLang = availableLanguages.find(
        availableLang => availableLang === values.lang
      )
      lang = foundLang || lang
    }

    return lang
  },
}
export default LanguageDetector
